var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Data } from './data';
import { Category } from './category';
import { ItemGroup } from './item-group';
import { Item } from './item';
var OrderItem = /** @class */ (function (_super) {
    __extends(OrderItem, _super);
    function OrderItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.class = "OrderItem";
        _this.total = 0;
        _this.groups = [];
        _this.groupIds = [];
        _this.itemIds = [];
        _this.quantity = 1;
        _this.combo = false;
        _this.modifiable = false;
        _this.handling = 0;
        _this.discount = 0;
        _this.points = 0;
        _this.discounts = [];
        _this.recommended = false;
        _this.items = [];
        return _this;
    }
    OrderItem.prototype.toProperty = function (name, value) {
        if (name == "items") {
            return Data.toDataArray(Item, value);
        }
        else if (name == "groups") {
            return Data.toDataArray(ItemGroup, value);
        }
        else {
            return _super.prototype.toProperty.call(this, name, value);
        }
    };
    OrderItem.isSet = function (oi) {
        if (oi.groups && oi.groups.length > 1) {
            return true;
        }
        var mainItem = OrderItem.getMainItem(oi);
        if (mainItem) {
            return Item.isSet(oi.category, mainItem);
        }
        if (oi.combo)
            return true;
        return false;
    };
    OrderItem.getMainItem = function (oi) {
        var item;
        if (oi.items && oi.items.length > 0) {
            item = oi.items[0];
        }
        else {
            item = oi.groups[0].items[0];
        }
        /*
        if(item && item.origin){
            item = item.origin;
        }*/
        return item;
    };
    OrderItem.prototype.setRecommended = function (isRec) {
        this.recommended = isRec;
    };
    OrderItem.flattenItems = function (oi) {
        /*
        var items = [];
        for(let group of oi.groups){
            for(let item of group.items){
                items.push(item);
            }
        }
        oi.items = items;
        */
        oi.items = OrderItem.getFlattenItems(oi, true);
    };
    OrderItem.getFlattenItems = function (oi, includeMods) {
        var items = [];
        for (var _i = 0, _a = oi.groups; _i < _a.length; _i++) {
            var group = _a[_i];
            if (!group.items)
                continue;
            for (var _b = 0, _c = group.items; _b < _c.length; _b++) {
                var item = _c[_b];
                items.push(item);
                if (includeMods && item.mgroups) {
                    for (var _d = 0, _e = item.mgroups; _d < _e.length; _d++) {
                        var mig = _e[_d];
                        for (var _f = 0, _g = mig.items; _f < _g.length; _f++) {
                            var item_1 = _g[_f];
                            item_1.modifier = true;
                            items.push(item_1);
                        }
                    }
                }
            }
        }
        return items;
    };
    OrderItem.toOrderItemsData = function (orderItems) {
        var result = [];
        for (var _i = 0, orderItems_1 = orderItems; _i < orderItems_1.length; _i++) {
            var orderItem = orderItems_1[_i];
            var tmp = OrderItem.toOrderItemData(orderItem);
            result.push(tmp);
        }
        return result;
    };
    OrderItem.toOrderItemData = function (orderItem) {
        var json = {};
        json["total"] = orderItem.total;
        json["groups"] = ItemGroup.toItemGroupsData(orderItem.groups);
        json["quantity"] = orderItem.quantity;
        json["category"] = Category.toCategoryData(orderItem.category);
        json["categoryId"] = orderItem.categoryId;
        json["cgroupId"] = orderItem.category.cgroupId;
        json["departmentId"] = orderItem.category.departmentId;
        json["handling"] = orderItem.handling;
        json["recommended"] = orderItem.recommended;
        return json;
    };
    return OrderItem;
}(Data));
export { OrderItem };
//# sourceMappingURL=order-item.js.map